module.exports = __webpack_public_path__ + "static/media/unassignVehicle.ace9c00c.svg";